import { observer } from 'mobx-react-lite';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { ETAPaymentMethod } from '~/api/ETA';
import { company } from '~/company/Company';
import { AdyenTimer } from '~/components/AdyenTimer/AdyenTimer';
import Icon from '~/components/Icon/Icon';
import Select from '~/components/Select/Select';
import adyenService from '~/services/Adyen';

import { AnalyticsEvent, analyticsService } from '~/services/analytics';
import { cartStore, checkoutStore, mainStore, orderStore } from '~/stores';

const AdyenCardPayment = () => {
  const { t } = useTranslation();
  const handleNewCard = (flag: boolean) => checkoutStore.setIsAddNewCard(flag);
  const handleAgreeChange = () =>
    checkoutStore.setAgreeSaveCard(!checkoutStore.agreeSaveCard);
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    if (!isReady) {
      setIsReady(true);
      return;
    }

    const shouldShowDropin =
      !Array.isArray(checkoutStore.payments) ||
      checkoutStore.payments.length === 0 ||
      checkoutStore.isAddNewCard;

    if (shouldShowDropin) {
      adyenService.initPayment();
    }
  }, [isReady, checkoutStore.isAddNewCard, checkoutStore.payments]);

  const paymentsChange = (val: string) => {
    checkoutStore.setPaymentsMethodId(val);
    checkoutStore.setIsDisabled(false);
    orderStore.setDefaultPayment(val);
    analyticsService.track(AnalyticsEvent.PURCHASE_PAYMENT_METHOD_FILLED_IN, {
      cart_id: undefined,
      payment_method: 'card',
      type: 'existing',
    });
    analyticsService.track(AnalyticsEvent.ADD_PAYMENT_INFO, {
      currency: orderStore.currency.toUpperCase(),
      payment_type: 'credit card',
      value: mainStore.toFloat(cartStore.finalPrice),
      items: cartStore.cartForFirebase,
      coupon: cartStore.promocode.value,
    });
  };

  return (
    <>
      {Array.isArray(checkoutStore.payments) &&
      checkoutStore.payments.length > 0 &&
      !checkoutStore.isAddNewCard ? (
        <>
          <div className="panel-section__content-payment-add-title-container">
            <p className="panel-section__content-payment-add-title">
              {t('cardNumber')}
            </p>
            <button
              className="button _no-padding _no-color"
              onClick={() => handleNewCard(true)}
            >
              <Icon type="card-add" size={24} />
              {t('addNewCard')}
            </button>
          </div>
          <Select
            attributeName="select-card"
            className="panel-section__content-payment-add-select"
            initialValue={checkoutStore.payments?.[0]?.text ?? ''}
            data={checkoutStore.payments}
            onChange={paymentsChange}
          />
          {checkoutStore.activePaymentMethod !== ETAPaymentMethod.Cash &&
            !company.hideFreezeMoneyMessage && (
              <p className="panel-section__content-payment-add-text">
                {t('phrases:moneyFreeze')}
              </p>
            )}
          {checkoutStore.error && (
            <div className="alert _error mt-10 z-auto">
              {checkoutStore.error}
            </div>
          )}
        </>
      ) : (
        <>
          <div className="panel-section__content-payment-add-title-container">
            <p className="panel-section__content-payment-add-title">
              {t('cardNumber')}
            </p>
            {checkoutStore.isAddNewCard &&
              Array.isArray(checkoutStore.payments) &&
              checkoutStore.payments.length > 0 && (
                <button
                  data-button="choose-card"
                  className="button _no-padding _no-color"
                  onClick={() => handleNewCard(false)}
                >
                  <Icon type="cards" size={24} />
                  {t('chooseCardInList')}
                </button>
              )}
          </div>
          <div id="adyen-dropin-container" />

          <AdyenTimer />

          <div className="checkbox-container">
            <label className="control__checkbox">
              <input
                data-checkbox="remember-me"
                type="checkbox"
                className="control__checkbox-input"
                checked={checkoutStore.agreeSaveCard}
                onChange={handleAgreeChange}
              />
              <span className="control__checkbox-mark" />
              {t('phrases:rememberMyCard')}
            </label>
          </div>

          {checkoutStore.error && (
            <div className="alert _error mt-10 z-auto">
              {checkoutStore.error}
            </div>
          )}
        </>
      )}
    </>
  );
};

export default observer(AdyenCardPayment);
